import { MetricCard, type MetricCardProps } from '@/features/cases'

/** Even grid of stat tiles — 4-up on wide screens, halving down to a single column on mobile. */
export function MetricGrid({ metrics }: { metrics: MetricCardProps[] }) {
  return (
    <div className="@xl/main:grid-cols-2 @4xl/main:grid-cols-4 grid grid-cols-1 gap-4">
      {metrics.map((metric) => (
        <MetricCard key={metric.label} {...metric} />
      ))}
    </div>
  )
}
